import React from "react";
import EventEmitter from "eventemitter3";

export interface SyncTarget {
  name: string;
  url: string;
}

export interface SyncEntry {
  name: string;
  status: string;
}

export class SyncManager extends EventEmitter {
  #entries: readonly SyncEntry[] = [];

  setStatus(name: string, status: string): void {
    const prev = this.#entries.find(e => e.name === name);
    if (prev != null && prev.status === status) return;
    this.#entries = this.#entries.some(e => e.name === name)
      ? this.#entries.map(e => e.name === name ? { name, status } : e)
      : [...this.#entries, { name, status }];
    this.emit('update');
  }

  getEntries(): readonly SyncEntry[] {
    return this.#entries;
  }
}

export const SyncManagerContext = React.createContext(new SyncManager());

export function useSyncStatuses(): readonly SyncEntry[] {
  const manager = React.useContext(SyncManagerContext);
  const subscribe = React.useCallback((callback: () => void) => {
    manager.on('update', callback);
    return () => { manager.off('update', callback); };
  }, [manager]);
  return React.useSyncExternalStore(subscribe, () => manager.getEntries());
}
